var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart2"},[_c('div',{staticClass:"chart",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }